import React, {useState, Fragment ,useEffect} from "react";
import { Auth, Hub } from "aws-amplify";
import Loading from "../Components/loading";
import { accessGranted } from "../Store/loginRedux/actions";
import { useDispatch, useSelector } from "react-redux";
import ModalContainer from "../Components/modal";
import {groupsEpi} from  '../Utils/constants';
import Home from "./Home";
import {storage} from '../Utils/storage'
import {validateUSer} from '../Utils/onlyProductAccess';
import useNavigate from '../customHook/useNavigate';
import { dataVidaPiloto } from "./asesorRg";
import ModalMaintenence from "../Components/modalMaintenence";

const Federate = () => {
  const [loading, setLoding] = useState(false);
  const [showModal  , setShowModal] = useState(false);

  const [openModal, setOpenModal] = useState(false);

  const granted = useSelector(
    state => state.login.granted
  );

  const channelCode = useSelector(
    state => state.login.channel
  );

  const dispatch = useDispatch();

  useNavigate({granted,channelCode});
  

  useEffect(() => {
    Hub.listen("auth", listenerAuth);
  }, []);

  const listenerAuth = ({ payload: { event, data } }) => {
    switch (event) {
      case "signIn":
        getAuth();
        break;
      case "signOut":
        break;
    }
  };

  const getAuth = () => {
    setLoding(true)
    Auth.currentAuthenticatedUser()
      .then(res => {
        const { idToken = {} } = res['signInUserSession'];
        const {given_name,email,middle_name} = idToken.payload;
        let groups = idToken.payload['cognito:groups']
        storage().setItem('jwt',idToken.jwtToken);
        if(groups){
          let index  = groups.findIndex(e=> validateUSer(e));
          
          if(index > -1){
            let first = given_name
            let username = `${given_name} ${middle_name}`; 
            let idClient = email;
            let access_configuration = groups[index] === process.env.REACT_APP_ROL_ADMIN;
            // TODO: Agregar a los usuario de la lista al nuevo rol vidapiloto
            const filterPiloto = dataVidaPiloto.some((e) => idClient === e.idClient);
            const variante = filterPiloto ? "vidapiloto" : "vida";
            const varianteAdmin = filterPiloto ? "vidapiloto" : "admin";
            const roles = {
              [process.env.REACT_APP_ROL_ADMIN]: varianteAdmin,
              [process.env.REACT_APP_ROL_RENTA]: 'renta',
              [process.env.REACT_APP_ROL_VIDA]: variante,
              [process.env.REACT_APP_ROL_TLMKT]: 'tlmkt',
              [process.env.REACT_APP_ROL_SUSCRIPTOR]: 'suscript',
              [process.env.REACT_APP_ROL_BROKER] : 'broker'
            };
            const channel = roles[groups[index]];
              dispatch(accessGranted({username,idClient,access_configuration,channel,first}))   
          }else{
            setShowModal(true)
          }
        }else{
          setShowModal(true)
        }
        
        setLoding(false)
      
      })
      .catch(e => {
          setLoding(false) 
      });
  };
  

  return (
    <Fragment>
      <Home/>
      {loading && <Loading />}
      <ModalContainer
          title={groupsEpi.title}
          open={showModal}
          login={true}
          message={groupsEpi.message_rol_invalidate}
          close={() => setShowModal(false)}
        />
      <ModalMaintenence openModal={openModal} setOpenModal={setOpenModal}/>
    </Fragment>
  );
};

export default Federate;

